
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Shield, Calendar } from 'lucide-react';

const IntroductionSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6 text-brand-charcoal-gray">Your Trusted Roofing Partner in the Carolinas</h2>
            <p className="text-lg mb-6 text-gray-600">
              Carolina Trophy Roofs has been delivering exceptional roofing solutions to homeowners and businesses throughout North Carolina. 
              Our commitment to quality materials, expert craftsmanship, and superior customer service has made us the preferred choice for all roofing needs.
            </p>
            <p className="text-lg mb-6 text-gray-600">
              We specialize in residential and commercial roofing, offering a comprehensive range of services from new installations and replacements to repairs and regular maintenance.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="flex items-start">
                <div className="bg-brand-trophy-gold/10 p-2 rounded-full mr-4">
                  <Shield className="h-6 w-6 text-brand-trophy-gold" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Quality Guaranteed</h3>
                  <p className="text-sm text-gray-500">Industry-leading warranties</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-brand-trophy-gold/10 p-2 rounded-full mr-4">
                  <Calendar className="h-6 w-6 text-brand-trophy-gold" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Timely Service</h3>
                  <p className="text-sm text-gray-500">Projects completed on schedule</p>
                </div>
              </div>
            </div>
            <Button asChild className="bg-brand-carolina-blue hover:bg-brand-carolina-blue/90">
              <Link to="/about">Learn About Us</Link>
            </Button>
          </div>
          <div className="relative">
            <img 
              src="/lovable-uploads/7bf145e7-ece8-4013-a652-719c82445f35.png" 
              alt="Carolina Trophy Roofs completed project with company sign" 
              className="rounded-lg shadow-xl w-full"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-lg">
              <div className="text-4xl font-bold text-brand-trophy-gold mb-1">5000+</div>
              <div className="text-gray-600">Projects Completed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroductionSection;
